var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskproArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 8,
    viewBox: "0 0 72 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427322423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25508",
    opacity: 0.3,
    d: "M2.82812 1L5.65655 3.82843L2.82812 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25509",
    opacity: 0.3,
    d: "M10.8281 1L13.6566 3.82843L10.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25510",
    opacity: 0.3,
    d: "M18.8281 1L21.6566 3.82843L18.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25511",
    opacity: 0.3,
    d: "M26.8281 1L29.6566 3.82843L26.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25512",
    opacity: 0.3,
    d: "M34.8281 1L37.6566 3.82843L34.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25513",
    opacity: 0.3,
    d: "M42.8281 1L45.6566 3.82843L42.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25514",
    opacity: 0.3,
    d: "M50.8281 1L53.6566 3.82843L50.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25515",
    opacity: 0.3,
    d: "M58.8281 1L61.6566 3.82843L58.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25516",
    opacity: 0.3,
    d: "M66.8281 1L69.6566 3.82843L66.8281 6.65685",
    stroke: "#FE815F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskproArrow);
export default __webpack_public_path__ + "static/media/askpro-arrow.95e39c20c39c4b487830c831e5ec0639.svg";
export { ForwardRef as ReactComponent };